"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentApiController = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class ComponentApiController {
    constructor() {
        this.initSubject = new rxjs_1.BehaviorSubject(false);
    }
    callApi(cb) {
        return new Promise((resolve, reject) => {
            if (this.initSubject.isStopped) {
                reject(new Error('DataGridApiController Error: api already destroyed'));
            }
            this.initSubject.pipe((0, operators_1.filter)(Boolean), (0, operators_1.take)(1)).subscribe(() => {
                if (!this.api) {
                    reject(new Error('DataGridApiController error: api not init'));
                    return;
                }
                try {
                    resolve(cb(this.api));
                }
                catch (err) {
                    reject(err);
                }
            }, (err) => {
                reject(err);
            });
        });
    }
    injectApi(api) {
        const needInit = !this.api;
        this.api = api;
        if (needInit) {
            if (this.initSubject.isStopped) {
                this.initSubject = new rxjs_1.BehaviorSubject(false);
            }
            this.initSubject.next(true);
        }
    }
    destroy() {
        this.initSubject.next(false);
        this.api = null;
        this.initSubject.complete();
    }
}
exports.ComponentApiController = ComponentApiController;
//# sourceMappingURL=ComponentApiController.js.map